const defaultRoute = "/claim";

export default defaultRoute;
